/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createRangeNode } from '../../factoriesAny.js';
export var RangeNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createRangeNode: createRangeNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRangeNode.generated.js
// module id = 516
// module chunks = 0